import { Quaternion, QuaternionLike, Vector3, Vector3Like } from "three";
import { roundToPrecision } from "../../utils/mathUtils";

type UnitScaler = (value: number | undefined | null) => number;

const vector3ToJson = (v: Vector3Like, precision: number, scaler: UnitScaler | null = null) : Vector3Like => {
    
    if (scaler) {
        v = {
            x: scaler(v.x),
            y: scaler(v.y),
            z: scaler(v.z)
        };
    }
    
    return {
        x: roundToPrecision(v.x, precision),
        y: roundToPrecision(v.y, precision),
        z: roundToPrecision(v.z, precision)
    };
};

const vector3FromJson = (v: Vector3Like, scaler: UnitScaler | null = null) : Vector3 => {

    if (scaler) {
        v = {
            x: scaler(v.x),
            y: scaler(v.y),
            z: scaler(v.z)
        };
    }
    return new Vector3(v.x, v.y, v.z);
};

const quaternionToJson = (q: { x: number; y: number; z: number; w: number }, precision: number) : QuaternionLike  => {
    return {
        x: roundToPrecision(q.x, precision),
        y: roundToPrecision(q.y, precision),
        z: roundToPrecision(q.z, precision),
        w: roundToPrecision(q.w, precision)
    };
}

const quaternionFromJson = (q: QuaternionLike) : Quaternion => {
    return new Quaternion(q.x, q.y, q.z, q.w);
}

export { vector3ToJson, vector3FromJson, quaternionToJson, quaternionFromJson };